export enum StatusRequest {
    SUCCESS = 'Success',
    FAILED = 'Failed'
}
